<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'ClampList',
    props: {
      maxItems: Number,
      items: Array,
    },
    data() {
      return {
        showMore: false,
      }
    },
  }
</script>
